/**
 * Toast Type Enum
 */

export enum ToastType {
  ERROR = 'error',
  INFO = 'info',
  FINGERPRINT_FAILED = 'fingerprint_failed',
  FINGERPRINT_INFO = 'fingerprint_info',
  RECEIVER_SUCCESS = 'receiver_success',
  RECEIVER_SUCCESS_VOIDED = 'receiver_success_voided',
  SUCCESS = 'success',
  WARNING = 'warning',
  SCANNING_INFO = 'scanning_info',
  PAIRING_FAILED = 'pairing_failed',
}

export enum ToastIcon {
  DEFAULT = 'icon-minus-circled',
  ERROR = 'icon-attention',
  FINGERPRINT_FAILED = 'icon-attention',
  FINGERPRINT_INFO = 'icon-info-circled-2',
  INFO = 'icon-info-circled-2',
  RECEIVER_SUCCESS = 'icon-check-circled',
  RECEIVER_SUCCESS_VOIDED = 'icon-check-circled',
  SUCCESS = 'icon-ok-2',
  WARNING = 'icon-attention-circled',
  SCANNING_INFO = 'icon-scan-spinner',
}

export enum MessageType {
  MODAL = 'modal',
  TOAST = 'toast',
}
